import axios from "axios";
import { store } from "../Redux";
import { Crypt } from "hybrid-crypto-ts";
import { public_encryption_key, url } from "../configs";
import { parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js'
import eventBus from '../configs/eventsBus'



const crypt = new Crypt();
// Builds a full international phone number (E.164, e.g. "+254712345678") from a country dial code
// and what the user typed, or null if that isn't a valid number - so a form can show an error
// instead of sending something like "+254NaN" (what '+' + parseInt(code) + parseInt('') gives for
// an empty or non-numeric field). A leading national "0" is dropped. The server re-checks this
// (spotpool_server helpers/phone.ts), this just catches it before the request.
export const buildPhone = (countryCode: string | number, localNumber: string): string | null => {
    const code = String(countryCode ?? '').replace(/\D/g, '')
    const digits = String(localNumber ?? '').replace(/\D/g, '').replace(/^0+/, '')
    if (!code || !digits) return null
    const parsed = parsePhoneNumberFromString('+' + code + digits)
    return parsed?.isValid() ? parsed.number : null
}

export const Api = (data: any) => new Promise((resolve, reject) => {
    const jwtToken = store.getState().jwtToken,
        encrypted = crypt.encrypt(
            public_encryption_key,
            JSON.stringify({...data, isWeb:true}),
        );
    axios.post(url, encrypted, {
        timeout: 20000,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': "Bearer " + jwtToken
        }
    }).then((resp) => {
        resolve(resp.data)
    }).catch((err: any) => {
        try {
            if (err.response?.status == 403)
                eventBus.dispatch('routes', { action: 'logOut' })
            else
                reject(err)
        } catch (err) {
            reject(err)
        }
    })
}),
    showHideLoader = (show?: boolean, message?: string) => {
        if (show)
            eventBus.dispatch('loader', { text: message })
        else
            eventBus.dispatch('loader', { action: 'close' })
    },
    checkWebCameraPermission = () => {
        return new Promise((resolve, reject) => {

            navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    resolve(true);
                    stream.getTracks().forEach(track => track.stop());
                })
                .catch((err) => {
                    console.error('Camera permission denied or error occurred', err);
                    alert('Please allow camera access in your browser settings.');
                    reject('Error');
                });
        });
    },
    getFormattedPhone = (phone: string) => {
        try {
            return parsePhoneNumber(phone).format('INTERNATIONAL')
        } catch (err) {
            return false
        }
    },
    numberWithCommas = (number: number | string) => {
        if (!number || number == 'None')
            number = 0
        number = parseFloat(number.toString())
        let numberString = (number as number).toFixed(2).toString(); // toFixed(2) adds two decimal places

        const parts = numberString.split(".");
        let integerPart = parts[0];
        const decimalPart = parts.length > 1 ? "." + parts[1] : "";

        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        numberString = integerPart + decimalPart;

        return numberString;
    },
    getAbbr = (name: string) => {
        const split = name.split(' ')
        return split[1] ? (split[0][0] + '' + split[1][0]).toUpperCase() : name.substring(0, 2).toUpperCase()
    },
    // `since` is when a device last flipped state (see lastStateChangeAt) - only meaningful to
    // call this while it's currently off, since that's the only state whose duration we surface.
    getDurationSince = (since?: string | Date) => {
        if (!since) return null
        const ms = Date.now() - new Date(since).getTime()
        if (ms < 0) return null
        const minutes = Math.floor(ms / 60000)
        if (minutes < 1) return 'just now'
        if (minutes < 60) return `${minutes}m`
        const hours = Math.floor(minutes / 60)
        if (hours < 24) return `${hours}h ${minutes % 60}m`
        const days = Math.floor(hours / 24)
        return `${days}d ${hours % 24}h`
    }


